module.exports = __webpack_public_path__ + "static/the-chill-bdc161f2cced232e7bd02089fa4680bf.jpg";